import React from "react";
import {
  Input,
  Checkbox,
  ListItemText,
  FormHelperText,
  InputLabel,
  Switch,
  MenuItem,
  Select,
  FormControl,
  FormControlLabel,
  TextField,
  RadioGroup,
  Radio,
  FormLabel,
  Autocomplete,
  Typography,
  TextareaAutosize,
  useTheme,
  Box,
} from "@mui/material";

export const renderTextField = ({
  label,
  input,
  isRequired,
  disabled,
  type,
  meta: { touched, invalid, error },
  width = "100%",
  paddingRight,
  paddingLeft,
  isSubmitted,
  placeholder,
  paddingBottom,
  handleKeyDown,
  endIcon,
  startIcon,
  variant,
  inputTextAlign,
  inputRef,
  helperText,
  //inErrorState,
}) => (
  <>
    <Box component="div" mb={0.6} sx={{ textAlign: "left" }}>
      <Typography
        variant="h2LatoMedium"
        sx={{ color: touched && error ? "#d32f2f" : undefined }}
      >
        {`${label}${isRequired ? "*" : ""}`}
      </Typography>
    </Box>
    <TextField
      // label={`${label}${isRequired ? "" : ""}`}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      variant={variant || "filled"}
      error={(touched && invalid) || (invalid && isSubmitted)}
      helperText={helperText ? helperText : touched && error}
      type={type}
      inputRef={inputRef}
      onKeyDown={handleKeyDown}
      sx={{
        width: width,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "center",
        borderColor: touched && error ? "#d32f2f" : undefined,
        input: {
          textAlign: inputTextAlign,
          color: "#003d4c",
          fontSize: "20px",
          fontFamily: "Lato-Semibold",
          paddingTop: "6px",
        },
      }}
      InputProps={{
        endAdornment: endIcon,
        startAdornment: startIcon,
        autoComplete: "disabled",
      }}
      {...input}
    >
      {helperText ? renderFromHelper({ touched, error }) : ""}
    </TextField>
  </>
);

export const renderTimeField = ({
  //label,
  input,
  //isRequired,
  disabled,
  type,
  meta: { touched, invalid, error },
  width = "100%",
  paddingRight,
  paddingLeft,
  isSubmitted,
  //placeholder = "",
  paddingBottom,
  endIcon,
  startIcon,
  variant,
  inputTextAlign,
  inputRef,
  helperText,
  //defaultValue,
  isChecked,
  //name,
  labelTextColor,
  onCheckBoxClick,
}) => (
  <Box sx={{ display: "flex" }}>
    <Checkbox
      checked={isChecked}
      onClick={(name) => onCheckBoxClick(name)}
      sx={{ padding: 0, paddingTop: "8px", marginRight: "10px" }}
    />
    <TextField
      // label={`${label}${isRequired ? "*" : ""}`}
      // placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      variant={variant || "standard"}
      error={(touched && invalid) || (invalid && isSubmitted)}
      helperText={helperText ? helperText : touched && error}
      type={type}
      inputRef={inputRef}
      sx={{
        width: width,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "center",
        input: {
          textAlign: inputTextAlign,
          color: labelTextColor || "#003d4c",
          fontSize: "20px",
          fontFamily: "Lato-Semibold",
        },
      }}
      InputProps={{
        endAdornment: endIcon,
        startAdornment: startIcon,
        autoComplete: "disabled",
      }}
      {...input}
    />
    {helperText ? renderFromHelper({ touched, error }) : ""}
  </Box>
);

export const MultilineTextArea = ({
  label,
  input,
  isRequired,
  meta: {
    touched,
    //invalid,
    error,
  },
  rows,
}) => {
  const theme = useTheme();
  return (
    <FormControl variant="standard" fullWidth={true}>
      <Typography
        variant="text4"
        sx={{ color: "rgba(0, 0, 0, 0.6)", marginBottom: 0.8 }}
      >
        {`${label}${isRequired ? "*" : ""}`}
      </Typography>
      <TextareaAutosize
        minRows={rows || 9}
        style={{
          border: `2px solid ${theme.palette.secondary.main}`,
          fontFamily: "Lato-Regular",
          fontSize: 16,
          padding: 8,
          "&:focus": {
            border: `2px solid ${theme.palette.secondary.main}`,
          },
          "&:focus-visible": {
            border: `2px solid ${theme.palette.secondary.main}`,
          },
        }}
        {...input}
      />
      {renderFromHelper({ touched, error })}
    </FormControl>
  );
};

export const MultiLineTextField = ({
  label,
  input,
  //isRequired,
  disabled,
  type,
  meta: { touched, invalid, error },
  width = "100%",
  paddingRight,
  paddingLeft,
  isSubmitted,
  placeholder,
  paddingBottom,
  endIcon,
  startIcon,
  isFocussed,
  rows,
}) => (
  <>
    <label style={{ display: "block", textAlign: "left", width: "100%" }}>
      <Typography
        variant="h4LatoHeavy"
        sx={{
          fontSize: 16,
          color: isFocussed ? undefined : "rgba(0, 0, 0, 0.6)",
        }}
      >
        {label}
      </Typography>
    </label>
    <TextField
      // label={`${label}${isRequired ? "*" : ""}`}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      variant="standard"
      // dangerouslySetInnerHTML={{ __html: innerhtmlContent }}
      error={(touched && invalid) || (invalid && isSubmitted)}
      helperText={touched && error}
      type={type}
      multiline
      rows={rows || 4}
      sx={{ width: width, paddingBottom, paddingRight, paddingLeft }}
      InputProps={{
        endAdornment: endIcon,
        startAdornment: startIcon,
        maxLength: 5,
      }}
      {...input}
    />
    <Typography
      variant="h4LatoMedium"
      sx={{ float: "right", color: "#003d4c" }}
    >
      {input.value?.length}/500 characters used
    </Typography>
  </>
);

export const renderSwitchField = ({ input, label, isRequired }) => (
  <div>
    <FormControlLabel
      control={
        <Switch
          checked={input.value ? true : false}
          onChange={input.onChange}
          {...input}
        />
      }
      label={`${label}${isRequired ? "*" : ""}`}
    />
  </div>
);

export const renderFromHelper = ({
  touched,
  error,
  //  showHelper
}) => {
  if (!(touched && error)) {
    return;
  } else {
    return (
      <FormHelperText error={touched && error}>
        {" "}
        {touched && error}
      </FormHelperText>
    );
  }
};

export const renderSelectField = ({
  input,
  label,
  meta: { touched, error },
  width = "100%",
  options = [],
  isRequired,
  isSubmitted,
  paddingRight,
  paddingLeft,
}) => (
  <>
    <Box component="div" mb={0.6} sx={{ textAlign: "left" }}>
      <Typography
        variant="h2LatoMedium"
        sx={{ color: touched && error ? "#d32f2f" : undefined }}
      >
        {`${label}${isRequired ? "*" : ""}`}
      </Typography>
    </Box>
    <FormControl
      error={(touched && error) || (error && isSubmitted)}
      sx={{ width: width, paddingRight, paddingLeft }}
      variant="filled"
    >
      {/* <InputLabel>{`${label}${isRequired ? "*" : ""}`}</InputLabel> */}
      <Select
        inputProps={{ name: input.name }}
        {...input}
        sx={{
          "& .MuiSelect-filled": {
            paddingTop: "10px",
            textAlign: "left",
            //borderBottom: touched && error ? "3px solid #d32f2f" : '3px solid #83D712',
          },
        }}
      >
        {options.map((item) => (
          <MenuItem
            key={item.value}
            value={item.value}
            sx={{ color: "#003d4c" }}
          >
            <Typography variant="h1LatoSemiBold">{item.text}</Typography>
          </MenuItem>
        ))}
      </Select>
      {renderFromHelper({ touched, error })}
    </FormControl>
  </>
);

export const renderMultiSelectField = ({
  label,
  meta: { touched, error },
  width = "100%",
  isRequired,
  selectedItems,
  handleChange,
  isSubmitted,
  menuOptions = [],
  input,
}) => (
  <FormControl
    error={(touched && error) || (error && isSubmitted)}
    sx={{ width, marginBottom: 16 }}
  >
    <InputLabel>{`${label}${isRequired ? "*" : ""}`}</InputLabel>
    <Select
      multiple
      value={selectedItems}
      onChange={handleChange}
      renderValue={(selected) => selected.join(", ")}
      input={
        <Input
          inputProps={{ name: input.name, value: selectedItems }}
          {...input}
        />
      }
    >
      {menuOptions.map((item) => (
        <MenuItem key={item.id} value={item.name}>
          <Checkbox checked={selectedItems.indexOf(item.name) > -1} />
          <ListItemText primary={item.description} />
        </MenuItem>
      ))}
    </Select>
    {renderFromHelper({ touched, error })}
  </FormControl>
);

export const renderRadioField = ({
  input,
  name,
  label,
  isRequired,
  options,
  value,
  //isSubmitted,
  customLabel,
  horizontal,
  labelTextColor,
  labelFontSize,
}) => (
  <div>
    <FormControl component="fieldset">
      {!customLabel ? (
        <FormLabel component="legend">{`${label}${isRequired ? "*" : ""
          }`}</FormLabel>
      ) : (
        customLabel
      )}
      <RadioGroup
        name={name}
        value={value}
        {...input}
        sx={{
          flexDirection: horizontal ? "row" : "",
          "& .MuiSvgIcon-root": { color: "#03952a" },
        }}
      >
        {options.map((item) => (
          <FormControlLabel
            key={item.id}
            value={item.value}
            control={<Radio />}
            label={item.text}
            sx={{
              color: labelTextColor || "#003d4c",
              fontFamily: "Lato-Regular",
              fontSize: labelFontSize || "20px",
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  </div>
);

export const renderAutocompleteField = ({
  input,
  label,
  meta: { touched, invalid, error },
  width = "100%",
  options,
  isRequired,
  disabled,
  paddingRight,
  isSubmitted,
  paddingLeft,
}) => {
  const defaultProps = {
    options: options,
    getOptionLabel: (option) => {
      return option.text;
    },
  };

  return (
    <FormControl
      error={(touched && error) || (error && isSubmitted)}
      sx={{ width: width, paddingRight, paddingLeft }}
    >
      <Autocomplete
        {...defaultProps}
        sx={{ borderColor: "red" }}
        inputValue={input.value}
        onInputChange={(event, newInputValue) => {
          input.onChange(newInputValue);
        }}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            {...input}
            error={(touched && invalid) || (invalid && isSubmitted)}
            label={`${label}${isRequired ? "*" : ""}`}
            margin="normal"
          />
        )}
      />
      {renderFromHelper({ touched, error })}
    </FormControl>
  );
};

export const renderCustomTextField = ({
  label,
  input,
  isRequired,
  disabled,
  type,
  meta: { touched, invalid, error },
  width = "100%",
  paddingRight,
  paddingLeft,
  isSubmitted,
  placeholder,
  paddingBottom,
  endIcon,
  startIcon,
  variant,
  inputTextAlign,
  inputRef,
  helperText,
  //inErrorState,
}) => (
  <>
    <Box component="div">
      <Typography variant="h1LatoMedium" sx={{ fontSize: "12px" }}>
        {`${label}${isRequired ? "" : ""}`}
      </Typography>
    </Box>
    <TextField
      // label={`${label}${isRequired ? "" : ""}`}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      variant={variant || "standard"}
      error={(touched && invalid) || (invalid && isSubmitted)}
      helperText={helperText ? helperText : touched && error}
      type={type}
      inputRef={inputRef}
      sx={{
        width: width,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "center",
        input: {
          textAlign: inputTextAlign,
          color: "#003d4c",
          fontSize: "20px",
          fontFamily: "Lato-Semibold",
        },
      }}
      InputProps={{
        endAdornment: endIcon,
        startAdornment: startIcon,
        autoComplete: "disabled",
      }}
      {...input}
    />
    {helperText ? renderFromHelper({ touched, error }) : ""}
  </>
);
